import { of, Subject } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import store from "../../../../app/store";
import { streamChat } from "../../../../api/chatbotApiClient";

const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId;
};

export const userMessage$ = new Subject();

export const botResponse$ = userMessage$.pipe(
  switchMap((message) =>
    streamChat(`${_orgClientId()}/chat`, message).pipe(
      // Isolate per-message errors so one failed stream doesn't kill the whole pipeline.
      catchError((err) => {
        console.error("Chat stream error:", err);
        return of({ data: "[DONE]" });
      }),
    ),
  ),
);
